<template>
<div class="form">
<a-card title="编辑">
        <v-gobackbutton slot="extra" >返回</v-gobackbutton>
        
        <a-form-model :model="modalState" ref="ruleForm" :rules="rules" :layout="formItemLayout"  :label-col="labelCol" :wrapper-col="wrapperCol">

            <a-form-model-item label="告警名称" prop="alertname" :labelCol="labelCol"
                :wrapperCol="wrapperCol" style="width:100%;margin-top:10px;">
                <a-input v-model="modalState.alertname" type="textarea" />
            </a-form-model-item>

            <a-form-model-item label="告警消息" prop="alertmsg" :labelCol="labelCol"
                :wrapperCol="wrapperCol" style="width:100%;margin-top:10px;">
                <a-input v-model="modalState.alertmsg" type="textarea" />
            </a-form-model-item>

            <a-form-model-item ref="usercode" label="选择接收人" prop="usercode">
                    <div>
                        <commonselecter :modalState="modalSta" @onModalHide="handleSelecterHide"></commonselecter>
                        <a-button @click="handleSelecterShow">选择接收人</a-button>
                    </div>
                    <!-- 权限列表 -->
                    <a-table :columns="columns_role1" :data-source="userlist" :loading="tLoading1" :pagination="false"
                              rowKey="usercode">
                    </a-table>
            </a-form-model-item>

           <a-form-model-item label="推送通道" prop="channel" :labelCol="labelCol"
                :wrapperCol="wrapperCol" style="width:100%;margin-top:10px;">

                <a-checkbox-group v-model="checkedList"  @change="onChange">
                    <a-row>
                        <a-col :span="8">
                            <a-checkbox value="钉钉">
                                    钉钉
                            </a-checkbox>
                        </a-col>
                        <a-col :span="8">
                            <a-checkbox value="短信">
                                    短信
                            </a-checkbox>
                        </a-col>
                        <a-col :span="8">
                            <a-checkbox value="邮件">
                                    邮件
                            </a-checkbox>
                        </a-col>
                    </a-row>
                </a-checkbox-group>
            </a-form-model-item>

            
            <a-form-model-item ref="dingdingid" label="钉钉群选择" prop="dingdingid"  v-if="is_show">
                <a-select v-if="is_vue_task"  v-model="modalState.dingdingid" show-search placeholder="请选择" @change="handleChange">
                    <a-select-option v-for="(item,index) in dingdinglist" :key="index" v-model="item.dingdingid"  >
                    {{item.dingdingid +'-'+item.dingdingname + '【' + item.dingdingurl + '】'}}
                    </a-select-option>
                </a-select>
                <span class="form_span" v-else>{{modalState.dingdingid}}</span>
            </a-form-model-item>

            <a-form-model-item   :wrapper-col="{ span: 14, offset: 10 }" >
                <a-button type="primary" @click="handleOk">
                    保存
                 </a-button>

                <a-button style="margin-left: 10px;" @click="handleCancel">
                    取消
                </a-button>
            </a-form-model-item>
        </a-form-model>

 </a-card>
</div>
  
</template>
<script>
import { mapState } from "vuex";
import commonselecter from '../../components/CommonSelecter'

const columns_role1 = [
    {
        title: '用户编码',
        dataIndex: 'usercode',
        align: 'center',
        width: 150
    },
    {
        title: '用户名称',
        dataIndex: 'username',
        align: 'center',
        width: 150
    }
];

export default {
    
    data() {
        return {
            columns_role1,
            is_vue_task : false,
            is_show:false,
            labelCol: {span: 3},
            wrapperCol: {span: 14},
            rules: {
                name: [
                    {required: true, message: '请输入钉钉群名', trigger: 'blur'},
                    {max: 50, message: '不能超过50位', trigger: 'blur'},
                ],
                url: [
                    {required: true, message: '请输入钉钉群地址', trigger: 'blur'},
                    {max: 100, message: '不能超过100位', trigger: 'blur'},
                ],
            },
            modalState:{
                id:'',
                alertname:'',
                alertmsg:'',
                receivers:'',
                receivername:'',
                channel:'',
                dingdingid:'',
            },
            modalSta:{
                title: '选择分组',//选择器标题
                isShow: false,
                rowsType: 'checkbox',//checkbox 多选  radio 单选
                selectkeys: undefined,
                filterAppcode: "usercode",//已选择key数组  [123,456]
                keyname: 'keyword',//唯一主键key
                // searchKey: 'rolecode',//搜索条件键值
                sc_params: {},
                selectedRowKeys: [],
                requestType: 'alarmmanager/userlist',
                columns: [
                    {
                        title: '用户编码',
                        dataIndex: 'usercode',
                        align: 'center',
                    },
                    {
                        title: '用户名称',
                        dataIndex: 'username',
                        align: 'center',
                    }
                ]
            },
            confirmLoading: false,
            formItemLayout:'horizontal',
            dingdinglist:[],
            tLoading1:false,
            actiontype:'',
            userlist:[],
            usercodes:[],
            checkedList: [],
        };
    },
    computed: {
        ...mapState("alarmconfig", {
            record: function(state) {
                return this.actiontype == "alertconfigadd" ? {
                    dingdingname: ''
                } : state.record;
            }
        })
    },

    methods: {
        handleOk() {
            this.confirmLoading = true;
            if (this.actiontype == "alertconfigadd"){
               
                //新增
                this.$store
                    .dispatch({
                        type: "alarmconfig/alertconfigadd" ,
                        params: this.modalState
                    })
                    .then((response) => {
                        if (response.data.success == '1') {
                            this.$router.push({
                                path: "alertconfiglist"
                            });
                        }

                    });
            }else{
                //编辑
                this.record.id = this.record.id;
                this.$store
                    .dispatch({
                        type: "alarmconfig/alertconfigedit",
                        params: this.modalState
                    })
                    .then((response) => {
                        if(response.data.success == '1'){
                            console.log(response)
                            this.handleCancel();
                            this.confirmLoading = false;
                        }
                    });
            }   
            
        },

        // 获取钉钉群名称
        handleChange(dingdingid) {
            console.log("value="+dingdingid)
            for(var i=0; i<this.dingdinglist.length; i++) 
            {
                var c = this.dingdinglist[i].dingdingid;
                if (dingdingid==c) {
                    this.modalState.dingdingname=this.dingdinglist[i].dingdingname;
                    console.log(c)
                    break;
                }
            }
        },

        onChange(checkedValues) {
            console.log('checked = ', checkedValues);
            var channelstr='';
            for(var i=0; i<checkedValues.length; i++) 
            {
                channelstr= checkedValues[i] +","+ channelstr
            }
            console.log('indexOf => ', channelstr.indexOf('钉钉'));
            // 显示/隐藏钉钉群选择
            if(channelstr.indexOf('钉钉')==-1){
                this.is_show=false
            }else{
                this.is_show=true
            }
            console.log('channelstr = ', channelstr);
            this.modalState.channel=channelstr;
        },

        getSearchGroupList() {
            let c_params = {
                urlparams: false,
                pageSize: 9999,
            }
            this.tLoading = true;
            this.$store.dispatch({
                type: "alarmmanager/userlist",
                params: c_params
            }).then((res) => {
                console.log(res);
                this.userlist = res.data.data.list;
                this.groupdata();
            })
        },
        
        groupdata() {
            let usercodes = []
            let that = this
            let userlist= that.userlist
            let groupids_ =that.modalState.receivers.split(",")
            for (let id of groupids_) { 
                let groupidlists = userlist.filter((item) => {
                    if (item.usercode == id) {
                        return item;
                    }
                });
                if (groupidlists.length > 0) {
                    usercodes.push(groupidlists[0])
                }
            }
            that.tLoading1 = true
            that.userlist = usercodes
            that.tLoading1 = false
        },

        //推送通道多选框设置
        checkedbox() {
            let that = this
            let checkedchannel =that.modalState.channel.split(",")
            that.checkedList = checkedchannel
            // 显示/隐藏钉钉群选择
            if(that.modalState.channel.indexOf('钉钉')==-1){
                this.is_show=false
            }else{
                this.is_show=true
            }
        },

        handleSelecterShow() {
            this.selectedRowKeys = this.modalState.receivers ? [this.modalState.receivers] : [];
            this.modalSta.selectkeys = this.modalState.receivers ? this.modalState.receivers.split(",") : [];
            this.modalSta.isShow = true;
        },

        handleSelecterHide: function (result) {
            this.modalSta.isShow = false;
            console.log(result)
            if (result) {
                let resultStr = []
                let resultnameStr = []
                for (let index = 0; index < result.length; index++) {
                    resultStr.push(result[index].usercode);
                    resultnameStr.push(result[index].username);
                }
                this.modalState.receivers = resultStr.join(",")
                this.modalState.receivername = resultnameStr.join(",")
                this.tLoading1 = true
                this.userlist = result
                this.tLoading1 = false
            }

        },

        handleCancel() {
            this.resetForm();
            this.$router.back(-1);
        },
        resetForm() {
            this.$refs.ruleForm.resetFields();
        },
    },

    mounted(){
        //页面加载完成-接口获取钉钉列表
        let c_params = {
            urlparams: false,
            pageSize: 9999,
        }
        this.$store.dispatch({
            type: "alarmconfig/dingdinglist",
            params: c_params
        }).then((res)=>{
            this.dingdinglist = res.data.data.list;
        });
        const {query, params} = this.$route;
        this.is_vue_task = true;
        this.actiontype=params.action;
        if (params.action != "alertconfigadd") {
            this.$store.dispatch({
                type: "alarmconfig/alertconfigdetails",
                params: query,
                showMsg: false
            }).then((res)=>{
                this.modalState = res.data.data;
                this.getSearchGroupList();
                this.checkedbox();
            });
        }
        
    },
    components: {
        commonselecter
    }
};
</script>

<style scoped>
.ant-form-inline .ant-form-item{
    margin-right:40px;
}
.form_span{
    font-size: 14px;
    font-weight: bolder;
}
</style>
